import React from 'react';
import { getInlineMarkDown, getMarkDown } from '../utils';

const TextCard = ({ message }) => {

    const header = (message.data && message.data.length)
        ? message.data[0].headerText
        : ''
    
    const subHeaderText = (message.data && message.data.length)
        ? message.data[0].subHeaderText
        : ''

    return (
        <div className='message card'>
            <div className='content' role='region' aria-live='polite' tabIndex={-1}>
                <h2 className='header' style={{ marginTop: 0}}>
                    {getInlineMarkDown(header)}
                </h2>
                <div className='body'>
                    {getMarkDown(subHeaderText)}
                </div>
            </div>
        </div>
    );
}

export default TextCard;
